<ng-container [ngSwitch]="true">
  <ng-container *ngSwitchCase="currentPath.includes('sales-monthly')">
    <app-estimator-calendar-select></app-estimator-calendar-select>
  </ng-container>
  <ng-container *ngSwitchCase="currentPath.includes('prod-weekly')">
    <app-production-calendar-filters></app-production-calendar-filters>
  </ng-container>
  <ng-container *ngSwitchCase="currentPath.includes('prod-monthly')">
    <app-production-calendar-filters></app-production-calendar-filters>
  </ng-container>
  <!-- <ng-container *ngSwitchCase="'/calendar/prod-monthly'">
    <app-production-calendar-filters></app-production-calendar-filters>
  </ng-container> -->
  <ng-container *ngSwitchCase="currentPath.includes('service-weekly')">
    <app-service-calendar-filters></app-service-calendar-filters>
  </ng-container>
  <ng-container *ngSwitchCase="currentPath.includes('service-monthly')">
    <app-service-calendar-filters></app-service-calendar-filters>
  </ng-container>
</ng-container>
